import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.swingsetupai.com/api';

const apiClient = axios.create({ baseURL: API_BASE_URL });

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export interface EmailStockItem {
    id: number;
    symbol: string;
    stockName: string;
    exchange: string;
    screenerName: string | null;
    screenerCode: string | null;
    capturedOn: string;
    capturedPrice: number;
    maxUpside: number | null;
}

const emailApi = {
    getAllStocks: async (): Promise<EmailStockItem[]> => {
        const response = await apiClient.get('/admin/email/stocks/all');
        return response.data.data;
    },

    sendNewStocksEmail: async (recipientType: string): Promise<string> => {
        const response = await apiClient.post('/admin/email/new-stocks', { recipientType });
        return response.data.message;
    },

    sendSingleStockEmail: async (stockId: number, recipientType: string): Promise<string> => {
        const response = await apiClient.post('/admin/email/single-stock', { stockId, recipientType });
        return response.data.message;
    },

    sendBulkStocksEmail: async (stockIds: number[], recipientType: string): Promise<string> => {
        const response = await apiClient.post('/admin/email/bulk-stocks', { stockIds, recipientType });
        return response.data.message;
    },

    sendNoStocksTodayEmail: async (recipientType: string): Promise<string> => {
        const response = await apiClient.post('/admin/email/no-stocks-today', { recipientType });
        return response.data.message;
    },

    sendSingleDayMovementEmail: async (stockId: number, movementPercent: number, recipientType: string): Promise<string> => {
        const response = await apiClient.post('/admin/email/single-day-movement', { stockId, movementPercent, recipientType });
        return response.data.message;
    },

    sendCustomEmail: async (subject: string, content: string, contentType: 'HTML' | 'TEXT', recipientType: string): Promise<string> => {
        const response = await apiClient.post('/admin/email/custom', { subject, content, contentType, recipientType });
        return response.data.message;
    },
};

export default emailApi;
